import React from "react";
import StarIcon from "images/icons/star-border.inline.svg";

const Stars = ({ stars, starColorClass }) => {
  let rating = 0;

  if (stars) {
    rating = (((Math.round((stars * 10) / 5) * 5) / 10) * 20).toString() + "%";
  }

  return (
    <React.Fragment>
      <div className="flex items-center">
        <div className={`flex relative ${starColorClass?.back}`}>
          {[...Array(5)].map((_, index) => (
            <div key={index} className="p-[2px]">
              <StarIcon
                className={`${starColorClass?.stroke} shrink-0 w-[14px] h-[14px]`}
              />
            </div>
          ))}

          <div
            className={`flex absolute top-0 overflow-hidden ${starColorClass?.fill}`}
            style={{ width: rating }}
          >
            {[...Array(5)].map((_, index) => (
              <div key={index} className="p-[2px]">
                <StarIcon
                  className={`${starColorClass?.stroke} shrink-0 w-[14px] h-[14px]`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Stars;
